function parseFiniteNumber(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    var trimmed = value.trim();
    if (!trimmed) return null;
    var numericValue = Number(trimmed);
    return Number.isFinite(numericValue) ? numericValue : null;
  }

  return null;
}

function buildCalibrationActionValues(liveValue, offset) {
  var numericLiveValue = parseFiniteNumber(liveValue);
  var numericOffset = parseFiniteNumber(offset);

  if (numericLiveValue === null) {
    return {
      valid: false,
      error: 'Live value is required before calibration'
    };
  }

  if (numericOffset === null) {
    return {
      valid: false,
      error: 'Offset must be a valid number'
    };
  }

  return {
    valid: true,
    foundAs: numericLiveValue,
    sourceReference: numericLiveValue + numericOffset,
    leftAs: numericLiveValue + numericOffset,
    offset: numericOffset
  };
}

function calculateCalibrationResult(liveValue, existingOffset, offset) {
  var numericLiveValue = parseFiniteNumber(liveValue);
  var numericOffset = parseFiniteNumber(offset);
  var numericExistingOffset = parseFiniteNumber(existingOffset);

  if (numericLiveValue === null || numericOffset === null) {
    return null;
  }

  return numericOffset + (numericLiveValue - (numericExistingOffset || 0));
}

function normalizeCalibrationActionFields(data) {
  var fields = ['offset', 'foundAs', 'sourceReference', 'leftAs'];
  var fieldLabels = {
    offset: 'Offset',
    foundAs: 'Found As',
    sourceReference: 'Source Reference',
    leftAs: 'Left As'
  };
  var normalized = {};
  var invalidField = null;

  fields.some(function (fieldName) {
    var numericValue = parseFiniteNumber(data && data[fieldName]);
    if (numericValue === null) {
      invalidField = fieldName;
      return true;
    }

    normalized[fieldName] = numericValue;
    return false;
  });

  if (invalidField) {
    return {
      valid: false,
      error: 'Calibration ' + fieldLabels[invalidField] + ' is missing or not numeric. Edit the calibration and save numeric readings before downloading the report.'
    };
  }

  return {
    valid: true,
    values: normalized
  };
}

module.exports = {
  buildCalibrationActionValues: buildCalibrationActionValues,
  calculateCalibrationResult: calculateCalibrationResult,
  normalizeCalibrationActionFields: normalizeCalibrationActionFields,
  parseFiniteNumber: parseFiniteNumber
};
